// extracted by mini-css-extract-plugin
module.exports = {"tabletSize":"768px","mobileSize":"414px"};